import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "../../store-types";

import { INFO_DATA_KEY } from "./info-data-constants";
import { InfoDataState } from "./info-data-types";

export const getStateInfoData = (appState: RootState): InfoDataState =>
  appState[INFO_DATA_KEY];

export const getInitialDictionariesLoaded = createSelector(
  getStateInfoData,
  (state: InfoDataState) => state.initialDictionariesLoaded
);
